import React, { useEffect, memo } from "react";
import ReactSlidy from "react-slidy";
import { useBanner } from "../../context/BannerContext";
import useSlider from "./hooks/useSlider";
import Skeleton from "./components/Skeleton";
import "react-slidy/lib/styles.css";
import "./reactSlidy.css";
import { icons } from "@a365/dsys";
import {
  BannerCard,
  BannerCard2,
  BannerCard3,
  BannerCard4,
  BannerCard5,
} from "../BannerCard";
import { useBreakpointDown } from "@a365/core";
import "./banners";

const {
  AirplaneTilt,
  CaretLeft,
  CaretRight,
  GlobeHemisphereWest,
  Sailboat,
  SuitcaseRolling,
} = icons;

const BannerPromo = memo(({ scrollToAnchor, setOpenMod }) => {
  const { bannerData } = useBanner();
  const { currentSlide, setCurrentSlide, goToNext, goToPrev } = useSlider(3); // Adjust total slides

  // auto-play
  // useEffect(() => {
  //   const interval = setInterval(goToNext, 5000);
  //   return () => clearInterval(interval);
  // }, [goToNext]);

  if (!bannerData || Object.keys(bannerData).length === 0) {
    return (
      <div className="w-full text-base">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="w-full text-base max-w-[1500px] mx-auto">
      <ReactSlidy slide={currentSlide} ease="ease-in-out" slideSpeed={1200}>
        <div
          className="animate-fadeInLarge flex flex-col mx-auto xl:flex-row 
        items-center justify-center w-full text-white py-6 gap-y-1 xl:gap-y-0 text-base gap-x-6 md:w-[548px] xl:w-full
        
        "
        >
          <div className="hidden xl:flex rounded-full bg-brand-comp-green h-[280px] flex-wrap items-center justify-center py-[78px] px-[27px]">
            <SuitcaseRolling size={123} className="text-icon-lighter" />
          </div>
          <BannerCard bannerData={bannerData} />
          <BannerCard2
            scrollToAnchor={scrollToAnchor}
            bannerData={bannerData}
          />
          <div className="hidden xl:flex rounded-full bg-brand-comp-yellow h-[280px] items-center justify-center p-[62px]">
            <AirplaneTilt size={156} className="text-icon-alt" />
          </div>
        </div>

        <div className="container-slide-2 relative flex flex-col mx-auto xl:flex-row items-center justify-center w-full text-white py-6 gap-y-1 xl:gap-y-0 text-base gap-x-6 md:w-[548px] xl:w-full">
          <div
            className="
            image-slider-2
            hidden
            xl:flex
            bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/home/img/CircleImgBanner.png')]
            min-w-[280px] h-[280px] w-[280px] rounded-full bg-cover bg-center bg-no-repeat
"
          ></div>
          <div className="relative left-0 xl:-left-4 px-4 xl:px-0 items-center justify-center xl:flex-row flex-col flex xl:gap-x-6 gap-y-1 xl:gap-y-0">
            <BannerCard3 bannerData={bannerData} />
            <BannerCard4 bannerData={bannerData} setOpenMod={setOpenMod} />
            <div className="hidden xl:flex items-center justify-center rounded-xl h-[280px] w-[278px] bg-brand-comp-lilac">
              <Sailboat
                size={98}
                weight="duotone"
                className="text-icon-darker"
              />
            </div>
          </div>
        </div>

        <div
          className="relative w-full flex items-center justify-center overflow-hidden mx-auto 
        md:w-[548px] xl:w-full"
        >
          <div
            className="hidden xl:flex items-center justify-center
           rounded-xl h-[280px] w-[180px] bg-brand-comp-lightblue"
          >
            <GlobeHemisphereWest
              weight="duotone"
              size={123}
              className="text-icon-default"
            />
          </div>

          <BannerCard5
            scrollToAnchor={scrollToAnchor}
            bannerData={bannerData}
          />
          <div
            className="hidden xl:block bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/banner/banner-slide-5.jpg')]
            w-[486px] h-[280px] bg-cover bg-center bg-no-repeat"
          ></div>
        </div>
      </ReactSlidy>
      <div className="Dots w-full flex items-center justify-center">
        <CaretLeft
          onClick={goToPrev}
          size={20}
          weight="bold"
          className={`mr-2 cursor-pointer ${currentSlide !== 0 ? "text-action-default" : "text-action-disabled"
            }`}
        />
        {[...Array(3)].map((_, i) => {
          return (
            <button key={i} onClick={() => setCurrentSlide(i)}>
              <div
                className={`w-2.5 h-2.5 mx-1 rounded-full ${i === currentSlide
                    ? "bg-action-default"
                    : "bg-action-disabled"
                  }`}
              ></div>
            </button>
          );
        })}
        <CaretRight
          onClick={goToNext}
          size={20}
          weight="bold"
          className={`ml-2 cursor-pointer ${currentSlide + 1 === 3
              ? "text-action-disabled"
              : "text-action-default"
            }`}
        />
      </div>
    </div>
  );
});

BannerPromo.displayName = "BannerPromo";
export default BannerPromo;
